import styled from 'styled-components';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

// COMPONENTS
import DialogCTA from '@/components/Dialogs/DialogCTA';

export const DialogStyled = styled(DialogCTA)`
  &.dialog-cta {
    &--inside-container {
      z-index: 1000 !important;
      top: ${p => p.theme.headerHeight || 0}px !important;
    }

    &--info {
      .MuiDialogContent-root {
        padding: 0;
      }

      .dialog-cta {
        &__content {
          min-height: auto;
          padding-bottom: 0;
          text-align: center;
        }

        &__description {
          padding-right: 24px;
          padding-left: 24px;

          ${breakpoints.down('xs')} {
            min-height: auto;
            padding-right: 16px;
            padding-left: 16px;
            padding-bottom: 24px;
          }
        }
      }
    }
  }
`;

export default DialogStyled;
